const getRpcUrl = () => {
    return "https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161";
    // return https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161
  }
  
  export default getRpcUrl;